module.exports = __webpack_public_path__ + "img/tw-btn_txt.69894616.png";